export default "__VITE_ASSET__BR$QaLcq__"